import {
  IsFullAccess,
  useAppSelector,
  useCreateHaSnapShotMutation
} from '@monorepo/shared';
import { t } from 'i18next';
import React, { useEffect } from 'react';
import { useState } from 'react';
import {
  Button,
  Form,
  IconButton,
  Input,
  Message,
  Modal,
  useToaster
} from 'rsuite';
import PlusIcon from '@rsuite/icons/Plus';
import { useParams } from 'react-router-dom';
import { ErrorToaster } from './InstanceStatus';
import { selectCurrentAccount } from '@monorepo/shared/store/accountSlice';
import { HomeElms } from '../../config/const';

interface IProps {
  region: Record<string, any>;
  maxNumber: number;
  callBackFn?: any;
}
const Textarea = React.forwardRef((props, ref: React.Ref<any>) => (
  <Input {...props} rows={5} as="textarea" ref={ref} />
));
export const SnapshotCreateBtn = ({
  region,
  maxNumber,
  callBackFn
}: IProps) => {
  const currentAccount = useAppSelector(selectCurrentAccount);
  const { instanceId, accountId } = useParams();
  const [showMessage, setShowMessage] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const toaster = useToaster();
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setShowMessage(false);
    setMessage('');
    setOpen(false);
  };
  const [formData, setFormData] = useState<Record<string, any>>({});
  const [snapshotCreate, createResult] = useCreateHaSnapShotMutation();
  const [message, setMessage] = useState<string>('');
  useEffect(() => {
    if (createResult.isSuccess && callBackFn) {
      callBackFn();
      handleClose();
    }
    if (createResult.isError) {
      ErrorToaster({
        toaster,
        error: createResult.error,
        title: 'Create snapshot failed!'
      });
      handleClose();
    }
  }, [createResult]);
  return (
    <>
      <IconButton
        title="Create Snapshot"
        icon={<PlusIcon />}
        appearance="default"
        disabled={!IsFullAccess(currentAccount, HomeElms.fcName)}
        circle
        className="icon-btn"
        onClick={handleOpen}
      />
      <Modal open={open} onClose={handleClose}>
        <Modal.Header>
          <Modal.Title>{<b>{t('common.createSnapshot.title')}</b>}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form fluid onChange={setFormData}>
            <Form.Group controlId="snapShotName">
              <Form.Control
                name="snapShotName"
                errorMessage={message}
                errorPlacement="bottomStart"
              />
            </Form.Group>
            <Form.Group controlId="snapShotDesc">
              <Form.Control name="snapShotDesc" accepter={Textarea} />
            </Form.Group>
            <Form.Group>
              <p style={{ color: 'black' }}>
                {`The max snapshot number is ${maxNumber}. Exceed the maximum numbers of snapshot will be deleted`}
              </p>
            </Form.Group>
            <Form.Group>
              <p style={{ color: 'black' }}>
                <b>{t('common.createSnapshot.note.part1')}</b>{' '}
                {t('common.createSnapshot.note.part2')}
              </p>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              if (formData && formData.snapShotName) {
                setShowMessage(false);
                setMessage('');
                snapshotCreate({
                  account_id: accountId,
                  user_id: currentAccount.user_id,
                  access_from_user_id:
                    currentAccount.access_from_user_id ||
                    currentAccount.access_from?.user_id,
                  instance_id: instanceId,
                  region: region,
                  snapshot_name: formData?.snapShotName,
                  desc: formData?.snapShotDesc
                });
              } else {
                setMessage(`${t('common.createSnapshot.errorMessage')}`);
                setShowMessage(true);
              }
            }}
            appearance="primary"
          >
            {t('common.createSnapshot.createBtn')}
          </Button>
          <Button onClick={handleClose} appearance="subtle">
            {t('common.createSnapshot.closeBtn')}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
